import request from '@/utils/request'

// 极验验证码-初始化加载
const user_gee_web_init = () => {
  return request({
    url: '/user/gee/web/init',
    method: 'get'
  })
}

// 获取公有资源临时上传凭证
const sts_public = () => {
  return request({
    url: '/user/sts/public',
    method: 'get'
  })
}

// 获取私有资源临时上传凭证
const sts_internal = () => {
  return request({
    url: '/user/sts/internal',
    method: 'get'
  })
}

// 提交反馈信息
const feedback_submit = (data) => {
  return request({
    url: '/user/feedback/submit',
    method: 'post',
    data
  })
}

// 单附件上传
const upload_file = (data, extend = {}) => {
  return request({
    method: 'post',
    url: '/portal/upload/file',
    data,
    ...extend
  })
}

// 多附件上传
const upload_files = (data) => {
  return request({
    method: 'post',
    url: '/portal/upload/files',
    data
  })
}

// 获取项目字典信息
const sys_dict_project = (params) => {
  return request({
    url: '/sys/dict/project',
    method: 'get',
    params
  })
}

export {
  upload_files,
  upload_file,
  user_gee_web_init,
  sts_public,
  sts_internal,
  feedback_submit,
  sys_dict_project
}
